import logo  from '../Assets/logoraffa-black.webp'
import '../Styles/menu.css'

function Menu() {
    const redirectSection = (e, id) => {
      e.preventDefault()
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
    }
  
  return (
    <div className="half-screen flex-center flex__gap-50 font-semi-bold text-dark padding-20">
        <nav className="flex-center flex__gap-50">
            <a  onClick={(e) => redirectSection(e, 'home-section')}>Inicio</a>
            <a onClick={(e) => redirectSection(e, 'insta-section')}>Instagram</a>
            <a onClick={(e) => redirectSection(e, 'tiktok-section')}>Tiktok</a>
        </nav>
        <div id="container-logo-star" className="flex-center">
            <div id="logo-star-img" className="img img-300">
                <img src={logo} alt="Raffa Fragoso" width="300" height="24"/>
            </div>
        </div>
        <nav className="flex-center flex__gap-50">
            <a onClick={(e) => redirectSection(e, 'awards-section')}>Premiações</a>
            <a onClick={(e) => redirectSection(e, 'spotify-section')}>Spotify</a>
            <a onClick={(e) => redirectSection(e, 'product-section')}>Loja</a>
        </nav>
    </div>
  )
}

export default Menu
